module.exports = __webpack_public_path__ + "img/1.a150ea1f.png";